import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const fetchDataTypeAnalytics = createAsyncThunk(
    "dataTypeAnalytics/fetchData",
    async (licenseKey, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.get(`/api/v1/analytic/application/data-type-dist/${licenseKey}`);
            return response.data.dailyDataAnalytics || []; 
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response ? error.response.data : "Network error");
        }
    }
);

const getDataTypeAnalyticsSlice = createSlice({
    name: "dataTypeAnalytics",
    initialState: {
        data: "null",
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataTypeAnalytics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDataTypeAnalytics.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload; 
            })
            .addCase(fetchDataTypeAnalytics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default getDataTypeAnalyticsSlice.reducer;
